import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import { useMemo } from 'react'
import { DropdownOption } from 'types'

interface PersonnelEntry {
  entry: {
    id: string
    data: {
      name: string
      role: string[]
      email: string
      status: string
    }
  }
}

export const useGetPersonnelOptions = () => {
  const { data, isLoading } = useGetRolodexEntriesByLoadOptions<
    PersonnelEntry[]
  >({
    type: ['personnel'],
    limit: 200,
  })

  const personnelOptions: DropdownOption[] = useMemo(() => {
    return (data || []).map((personnel) => ({
      value: personnel.entry.data.email,
      label: `${personnel.entry.data.name} - ${personnel.entry.data.role.join(
        ', '
      )}`,
    }))
  }, [data])

  return {
    personnelOptions,
    isLoading,
  }
}
